import { Helpers } from '../../helpers';
import { IRigContractStatus } from '../../interfaces/irig-contract-status';
import { RigContract } from '../rig-contract';
import { RigRateType } from '../rig-rate-type';

export class RigContractStatusBase {
  RigContractStatusId: number;
  Description: string;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  RigContracts_RigContractStatus?: Array<RigContract> | null;
  RigRateTypes_RigContractStatus?: Array<RigRateType> | null;

  constructor(item?: IRigContractStatus) {
    if (item) {

      this.RigContractStatusId = item.RigContractStatusId;
      this.Description = item.Description;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.RigContracts_RigContractStatus = Helpers.createClassArray(RigContract, item.RigContracts_RigContractStatus);
      this.RigRateTypes_RigContractStatus = Helpers.createClassArray(RigRateType, item.RigRateTypes_RigContractStatus);
    }
  }
}